var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainPage',{attrs:{"isShowLogout":"","title":_vm.$t('licenses')}},[_c('v-row',[_c('v-col',{staticClass:"col-12"},[_c('LicensesTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }